<dx-data-grid
  *ngIf="vehicleService"
  height="100%"
  width="auto"
  [dataSource]="vehicleService.invoices"
  [remoteOperations]="false"
  (onRowInserting)="onInvoiceInserting($event)"
  (onRowUpdating)="onInvoiceUpdating($event)"
  (onRowRemoving)="onInvoiceRemoving($event)">
  <!-- Settings -->
  <dxo-editing mode="row" [allowAdding]="true" [allowDeleting]="true" [allowUpdating]="true"> </dxo-editing>
  <dxo-editing [allowAdding]="true" [allowDeleting]="true" [allowUpdating]="true"></dxo-editing>
  <dxo-export [enabled]="true" fileName="invoices-export"></dxo-export>

  <!-- Columns -->
  <dxi-column caption="Invoice ID" dataField="invoiceId" dataType="string" [allowEditing]="true">
    <dxi-validation-rule type="required" message="Invoice ID is required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column
    caption="Amount"
    dataField="amount"
    dataType="number"
    format="#,##0.00"
    alignment="right"
    [allowEditing]="true">
    <dxi-validation-rule type="required" message="Amount is required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column caption="Description" dataField="description" dataType="string" [allowEditing]="true"> </dxi-column>

  <dxi-column
    caption="Saved At"
    dataField="updatedAt"
    dataType="date"
    format="shortDateShortTime"
    [allowEditing]="false"></dxi-column>
  <!-- Templates -->
</dx-data-grid>
